<template>
  <div class="header">
    <div class="header-nav-bar">
      <div class="menu-btn">
        <button class="svg-btn" @click="showDrawer" v-if="isHome">
          <svg viewBox="0 0 24 24">
            <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
          </svg>
        </button>
        <button class="svg-btn" @click="goBack" v-else>
          <svg viewBox="0 0 24 24">
            <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
          </svg>
        </button>
      </div>

      <router-link to="/" style="display: flex;justify-content: center;align-items: center">
        <!--<img v-lazy="'../../static/img/logo.png'" class="logo">-->
      </router-link>

      <div class="header-nav-list">
        <ul>
          <li><router-link to="/"><a class="hover-highlight">Home</a></router-link></li>
          <li><router-link to="/about"><a class="hover-highlight">About Us</a></router-link></li>
          <!--<li><router-link to="/all"><a class="hover-highlight">Products</a></router-link></li>-->
          <!--<li><router-link to="/plans"><a class="hover-highlight">Design</a></router-link></li>-->
          <li><router-link to="/contact"><a class="hover-highlight">Contacts</a></router-link></li>
        </ul>
      </div>
      <!--<router-link to="/cart">-->
        <!--<button class="svg-btn">-->
          <!--<svg viewBox="0 0 24 24">-->
            <!--<path d="M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5A1,1 0 0,0 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z" />-->
          <!--</svg>-->
          <!--<div class="badge" v-if="!this.$store.getters.isCartEmpty">{{this.$store.state.cart.lineItemCount}}</div>-->
        <!--</button>-->
      <!--</router-link>-->
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      isHome () {
        return this.$route.name === 'Home'
      }
    },
    methods: {
      showDrawer () {
//        console.log(this.$store.state.isDrawerActive)
        this.$store.commit('showDrawer')
      },
      goBack () {
        this.$router.back()
        this.$store.commit('hidePdf')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a {
    text-decoration: none;
    color: #000;
    text-transform: uppercase;
    transition: all .3s;
  }
  svg {
    width: 24px;
    height: 24px;
    fill: #000;
    transition: fill .3s;
  }
  svg:hover {
    fill: #0288D1;
  }
  .hover-highlight:hover {
    color: #0288D1;
  }
  .header {
    background-color: rgba(255,255,255,.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 60px;
    color: #000;
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);*/
    z-index: 3;
  }
  .header-title {
    display: none;
  }
  .logo {
    width: 70px;
    height: auto;
  }
  .header-nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
  }
  .header-nav-list ul li {
    font-size: 110%;
    font-weight: 500;
    display: inline;
    padding: 0 15px;
  }
  .svg-btn {
    background: none;
    width: 45px;
    height: 45px;
    border: none;
    outline: none;
    cursor: pointer;
    position: relative;
    -webkit-tap-highlight-color: transparent;
  }
  .badge {
    background-color: #000;
    color: #FFF;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 120%;
    position: absolute;
    top: 0;
    right: 2px;
    border-radius: 50%;
  }
  .menu-btn {
    display: none;
  }

  /*styles for smaller screens*/

  @media (max-width: 767px) {
    .header-nav-list {
      display: none;
    }
    .header-title {
      display: block;
      font-size: 110%;
      font-weight: 500;
      text-transform: uppercase;
    }
    svg:hover {
      fill: #000;
    }
    .menu-btn {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// Header.vue?2ccd7dd2